import React from 'react';
import { Flex, Text } from '@/components/ui';
import { useTheme } from '@/theme';

interface InfoRowProps {
  label: string;
  value?: string;
}

/**
 * 라벨-값 쌍을 수직 배치로 표시하는 공통 컴포넌트.
 * CompanyPage, Sites 등 정보 카드 내부에서 사용.
 */
export const InfoRow: React.FC<InfoRowProps> = ({ label, value }) => {
  const { theme } = useTheme();

  return (
    <Flex direction="column" align="start" gap={2}>
      <Text size="sm" color={theme.colors.text.secondary}>
        {label}
      </Text>
      <Text size="md" color={theme.colors.text.primary}>
        {value || '-'}
      </Text>
    </Flex>
  );
};
